import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import { SocketProvider } from './context/SocketContext';
import LandingPage from './pages/Landing.page';
import LobbyPage from './pages/Lobby.page';

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SocketProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/lobby/:lobbyId" element={<LobbyPage />} />
          </Routes>
        </SocketProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
